import React from 'react'
import { motion } from "framer-motion";

const Animation = ({darkMode,isMobileOrTablet}) => {
    const Colors =[
        "#FF00FF",  // Magenta
        "#55becc",  // Light Cyan Blue
        "#008080",  // Teal
        "#cb73ec",  // Soft Purple
        "#ef3087",  // Pink
        "#808080",  // Gray
        "#00FFFF",  // Aqua
        "#800000",  // Maroon
        "#FFD700",  // Gold
        "#FF4500",  // Orange Red
        "#32CD32",  // Lime Green
        "#4B0082",  // Indigo
        "#FF6347",  // Tomato
        "#4682B4",  // Steel Blue
        "#ADFF2F"   // Green Yellow
      ]

  return (
    <motion.svg
    viewBox="0 0 1320 300"
    initial={{ opacity: 0, y: -50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1 }}
    className="w-full mt-8"
  >
    <motion.text
      x="50%"
      y="50%"
      textAnchor="middle"
      fontSize={isMobileOrTablet ? "70":"66"}
      fontWeight="bold"
      fill={darkMode ? "#000" : "#fff"}
      initial={{ fill: "#ff6347" }}
      animate={{ fill: Colors }}
      transition={{ repeat: Infinity, duration:5 }}
      style={{ transformOrigin: "center",flexWrap:"wrap" }}
    >
        Connect with us to grow your business! .
    </motion.text>
  </motion.svg>
  )
}

export default Animation
